import { Asterisk } from "lucide-react";

const WORDS = ["Peer Support", "CDCA Counseling", "Life Coaching", "Columbus, Ohio", "In-person or telehealth", "Your recovery goals"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-serif-display whitespace-nowrap px-8 text-4xl italic text-[#1E2621] sm:text-6xl">{w}</span>
        <Asterisk className="h-7 w-7 text-[#C86D51]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="marquee-wrap overflow-hidden border-y border-[#E2DCD0] bg-[#F4F1EA] py-8 sm:py-10" data-testid="editorial-marquee" aria-label="Our services">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
